import React from "react";
import { useParams } from "react-router";
import ESRDAnalyticalMethods2020 from "./ESRDAnalyticalMethods2020";
import ESRDAnalyticalMethods2021 from "./ESRDAnalyticalMethods2021";
import ESRDAnalyticalMethods2022 from "./ESRDAnalyticalMethods2022";
import ESRDAnalyticalMethods2023 from "./ESRDAnalyticalMethods2023";
import ESRDAnalyticalMethods2024 from "./ESRDAnalyticalMethods2024";
import ESRDAnalyticalMethods2025 from "./ESRDAnalyticalMethods2025";
import ESRDAnalyticalMethods2026 from "./ESRDAnalyticalMethods2026";

const ESRDAnalyticalMethods = () => {
  const { year } = useParams();
  if (year === "2020") {
    return <ESRDAnalyticalMethods2020 />;
  } else if (year === "2021") {
    return <ESRDAnalyticalMethods2021 />;
  } else if (year === "2022") {
    return <ESRDAnalyticalMethods2022 />;
  } else if (year === "2023") {
    return <ESRDAnalyticalMethods2023 />;
  } else if (year === "2024") {
    return <ESRDAnalyticalMethods2024 />;    
  } else if (year === "2025") {
    return <ESRDAnalyticalMethods2025 />;    
  } else if (year === "2026") {
    return <ESRDAnalyticalMethods2026 />;          
  } else {
    return null;
  }
};

export default ESRDAnalyticalMethods;
